import { GzMaintenanceWindowsContainerWebComponent } from './component/GzMaintenanceWindowsContainerWebComponent';

export { GzMaintenanceWindowsContainerWebComponent };
